export default __webpack_public_path__ + "static/media/includeImg2.857f6f43.jpg";